import { useIsMobile } from '@/hooks/useIsMobile';
import ArticleCardSkeleton from '@/components/skeletons/ArticleCardSkeleton';

function CategoryPageSkeleton() {
  const isMobile = useIsMobile();

  return isMobile ? (
    <div className='mt-5 px-4 md:container md:mx-auto pb-8'>
      <header className='flex items-center justify-between w-full mb-3'>
        <div className='bg-gray-200 h-[27px] w-28 animate-pulse rounded-full' />
        <div className='bg-gray-200 h-[40px] w-[40px] animate-pulse rounded' />
      </header>

      <div className='flex gap-3 px-3 mt-[28px] border-b border-gray-200 pb-3'>
        <div className='bg-gray-200 w-20 h-[20px] animate-pulse rounded-full' />
        <div className='bg-gray-200 w-20 h-[20px] animate-pulse rounded-full' />
      </div>

      <div className='mt-3.5'>
        <ArticleCardSkeleton imagePosition='top' />
        <ArticleCardSkeleton background='white' layout='noImageMobile' />
        <ArticleCardSkeleton background='white' layout='noImageMobile' />
      </div>
    </div>
  ) : (
    <div className='mt-9 px-4 pb-4 md:container md:mx-auto relative md:grid grid-cols-[218px_1fr] lg:grid-cols-[286px_1fr] gap-4 xl:gap-6 grid-rows-[max-content_max-content]'>
      <div className='rounded-md bg-white overflow-hidden shadow-sm h-min'>
        <div className='h-[48px] bg-gray-200 p-4 pt-3.5'>
          <div className='h-5 bg-gray-300 animate-pulse w-[130px] rounded-full' />
        </div>

        <div className='h-[44px] bg-gray-50 p-4 pt-3.5 flex items-center justify-between'>
          <div className='h-5 bg-gray-200 animate-pulse w-[165px] rounded-full' />
          <div className='h-5 w-5 bg-gray-200 animate-pulse rounded-full' />
        </div>
        <div className='flex flex-col gap-6 px-7 py-5'>
          <div className='h-4 bg-gray-200 animate-pulse w-[165px] rounded-full' />
          <div className='h-4 bg-gray-200 animate-pulse w-[165px] rounded-full' />
          <div className='h-4 bg-gray-200 animate-pulse w-[165px] rounded-full' />
          <div className='h-4 bg-gray-200 animate-pulse w-[165px] rounded-full' />
          <div className='h-4 bg-gray-200 animate-pulse w-[165px] rounded-full' />
        </div>
        <div className='h-[44px] bg-gray-50 p-4 pt-3.5 flex items-center justify-between'>
          <div className='h-5 bg-gray-200 animate-pulse w-[160px] rounded-full' />
          <div className='h-5 w-5 bg-gray-200 animate-pulse rounded-full' />
        </div>
        <div className='h-[44px] bg-gray-50 p-4 pt-3.5 flex items-center justify-between'>
          <div className='h-5 bg-gray-200 animate-pulse w-[160px] rounded-full' />
          <div className='h-5 w-5 bg-gray-200 animate-pulse rounded-full' />
        </div>
        <div className='h-[44px] bg-gray-50 p-4 pt-3.5 flex items-center justify-between'>
          <div className='h-5 bg-gray-200 animate-pulse w-[170px] rounded-full' />
          <div className='h-5 w-5 bg-gray-200 animate-pulse rounded-full' />
        </div>
      </div>

      <div className='articles h-min-content w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 md:gap-4 xl:gap-6 md:grid-rows-[repeat(auto-fit,minmax(30px,min-content))]'>
        <ArticleCardSkeleton className='col-span-full' summaryLineCount={3} />

        <div className='flex gap-3 px-3 mt-[10px] border-b border-gray-200 pb-3 col-span-full'>
          <div className='bg-gray-200 w-20 h-[20px] animate-pulse rounded-full' />
          <div className='bg-gray-200 w-20 h-[20px] animate-pulse rounded-full' />
        </div>

        {Array.from({ length: 9 }, (_, index) => (
          <ArticleCardSkeleton key={index} layout='noImage' />
        ))}
      </div>
    </div>
  );
}

export default CategoryPageSkeleton;
